import { client } from "../utils/netlify";

/*
 * @param request - line items ids to be removes
 */
export const reportError = async (error, error2) => {
    try {
        // Check if the error or error2 contains the word 'minified' after converting to JSON string
        // If it does, return an empty object
        if ((error && JSON.stringify(error).includes('minified')) || (error2 && JSON.stringify(error2).includes('minified'))) {
            return {};
        }
        if (!error || Object.keys(error).length === 0) {
          console.warn("reportError called with empty error object");
          return {};
        }
        let request = {};
        let request2 = {};
        let resp;
        request.message = error;
        resp = await client("error-log", request)
        if(error2){
          request2.message2 = error2;
          resp = await client("error-log", request2)
        }
        return resp;
    } catch (error) {
      console.error("Error in report error", error)
      return {}
    }
  };